module.exports = __webpack_public_path__ + "static/img/14.5ed513b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/14.png
// module id = GxLd
// module chunks = 2